import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'customer-icon-text',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
  ],
  template: `
  <div class="fx-row fx-align-center fx-justify-start fx-gap-3">
    <mat-icon
      class="s-6 min-s-6 tw-text-orange-500"
      [fontIcon]="fontIcon">
    </mat-icon>
    <span class="text-grey-400 tw-text-base tw-font-medium">{{ text }}</span>
  </div>
  `,
  styleUrls: ['./icon-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconTextComponent {
  @Input() fontIcon = 'warning';
  @Input() text = '';
}
